<template>
  <img v-if="username === 'ep6346!'" style="width:100%;" src="@/assets/images/_temp_dashboard.svg" />

  <div v-else-if="username === 'gagc4680!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gagc4680_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gagc4680_2.svg" />
  </div>

  <div v-else-if="username === 'gsgc2901!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2901_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2901_2.svg" />
  </div>
  <div v-else-if="username === 'gsgc2902!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2902_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2902_2.svg" />
  </div>

  <div v-else-if="username === 'gsgc2903!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2903_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsgc2903_2.svg" />
  </div>
  <div v-else-if="username === 'gsndc2760!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2760_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2760_2.svg" />
  </div>
  <div v-else-if="username === 'gsndc2762!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2762_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2762_2.svg" />
  </div>

  <div v-else-if="username === 'gsndc2765!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2765_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2765_2.svg" />
  </div>

  <div v-else-if="username === 'gsndc2782!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2782_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsndc2782_2.svg" />
  </div>
  <div v-else-if="username === 'gsnd2760!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gsnd2760_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gsnd2760_2.svg" />
  </div>

<!--  대구중구-->
  <div v-else-if="username === 'dgjg2250!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2250_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2250_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2332!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2332_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2332_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2333!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2333_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2333_2.svg" />
  </div>
  <div v-else-if="username === 'dgjg2335!'">
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2335_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/dgjg2335_2.svg" />
  </div>

<!--  광주남구-->
  <div v-else-if="username === 'gjng2900!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2900_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2900_2.svg" />
  </div>
  <div v-else-if="username === 'gjng2920!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2920_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2920_2.svg" />
  </div>
  <div v-else-if="username === 'gjng2921!'">
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2921_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/gjng2921_2.svg" />
  </div>

<!-- -->
  <div v-else-if="username === 'leesh0001!'">
    <img style="width:100%;" src="@/assets/images/dashboard/leesh0001_1.svg" />
    <img style="width:100%;" src="@/assets/images/dashboard/leesh0001_2.svg" />
  </div>

  <vs-row v-else>
    <!--  PC -->
    <vs-col v-if="this.verticalNavMenuWidth === 'default'">
<!--      <div class="flex mb-4" style="justify-content: end;">-->
<!--        <vs-button color="secondary" @click="()=>{-->
<!--          this.$router.push({name:'smart-report'})-->
<!--        }">스마트보고서</vs-button>-->
<!--      </div>-->
      <div class="dashboard-layout-2">
        <home-notification-card title="은평구청 안전·보건 경영 시스템 " :disabled="myInfo.is_superuser >= 1 ? false : true"/>
        <community-healthinfo-card />
        <community-business-news-card />
        <community-work-news-card />
      </div>
      <div v-if="hasDashboardCharts" class="dashboard-layout-auto">
        <component v-for="(chart, idx) in hasDashboardCharts" :key="idx" :is="chart.component" :dataType="getDataType(chart.component, chart.donutType)"/>
      </div>
      <div v-if="successLoadGraph && !hasDashboardCharts" class="dashboard-layout-auto">
        <donut-chart01 dataType="project"/>
        <donut-chart02 dataType="project"/>
        <donut-chart03 dataType="project"/>
<!--        <donut-chart04 dataType="project"/>-->
        <donut-chart05 dataType="project"/>
        <health-safety-budget-execution-rate-chart data-type="project"/>
        <donut-chart06 dataType="project"/>
        <donut-chart07 dataType="project"/>
        <donut-chart08 dataType="project"/>
        <donut-chart09 dataType="project"/>
        <donut-chart10 dataType="project"/>
        <donut-chart11 dataType="project"/>
        <donut-chart12 dataType="project"/>
        <donut-chart13 dataType="project"/>
        <donut-chart14 dataType="project"/>
      </div>
    </vs-col>


    <!--  Mobile -->
    <vs-col v-else>
      <div class="m-dashboard-menu px-4 mb-4">
        <router-link v-for="menu in mobileCardMenus" :to="menu.url" class="item" style="background: #fff;">
          <div>
            <div class="mt-4 mb-2 flex justify-center">
              <feather-icon :icon="menu.icon" />
            </div>
            <div class="text-center">
              <span style="font-size:0.92rem; font-weight: 500; color: #353535;">{{menu.name}}</span>
            </div>
          </div>
        </router-link>

      </div>
      <vs-card class="m-alarm-list mx-4">
        <div>
          <h5><i class="dot"></i>알림현황 <span>(최근 {{alertList.length}}건)</span> </h5>
        </div>
        <div v-for="alert in alertList" class="mt-3 p-3 board" @click="onClickAlert(alert)">
          <p style="font-size: 13px; color: #000; font-weight: 400">{{alert.message}}</p>
          <p class="mt-2" style="font-size: 12px; color: #696D71; font-weight: 400">{{alert.created_at}}</p>
        </div>
        <div v-if="alertList.length === 0" class="mt-3 p-6 board">
          <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import HomeNotificationCard from '@/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/components/CommunityBusinessNewsCard'
import DonutChart01 from '@/views/graph/DonutChart01'
import DonutChart02 from '@/views/graph/DonutChart02'
import DonutChart03 from '@/views/graph/DonutChart03'
import DonutChart04 from '@/views/graph/DonutChart04'
import DonutChart05 from '@/views/graph/DonutChart05'
import DonutChart06 from '@/views/graph/DonutChart06'
import DonutChart07 from '@/views/graph/DonutChart07'
import DonutChart08 from '@/views/graph/DonutChart08'
import DonutChart09 from '@/views/graph/DonutChart09'
import DonutChart10 from '@/views/graph/DonutChart10'
import DonutChart11 from '@/views/graph/DonutChart11'
import DonutChart12 from '@/views/graph/DonutChart12'
import DonutChart13 from '@/views/graph/DonutChart13'
import DonutChart14 from '@/views/graph/DonutChart14'
import HealthSafetyBudgetExecutionRateChart from '@/views/graph/HeathSafetyBudgetExecutionRateChart'
import DonutChart16 from '@/views/graph/DonutChart16'
import DonutChart17 from '@/views/graph/DonutChart17'
import DonutChart18 from '@/views/graph/DonutChart18'
import DonutChart19 from '@/views/graph/DonutChart19'
import DonutChart20 from '@/views/graph/DonutChart20'
import DonutChart21 from '@/views/graph/DonutChart21.vue'
import DonutChart22 from '@/views/graph/DonutChart22.vue'
import DonutChart23 from '@/views/graph/DonutChart23.vue'
import DonutChart24 from '@/views/graph/DonutChart24.vue'
import DonutChart25 from '@/views/graph/DonutChart25.vue'
import DonutChart26 from '@/views/graph/DonutChart26.vue'
import DonutChart27 from '@/views/graph/DonutChart27.vue'
import DonutChart28 from '@/views/graph/DonutChart28.vue'
import DonutChart29 from '@/views/graph/DonutChart29.vue'
import DonutChart30 from '@/views/graph/DonutChart30.vue'
import DonutChart31 from '@/views/graph/DonutChart31.vue'
import DonutChart32 from '@/views/graph/DonutChart32.vue'
import DonutChart33 from '@/views/graph/DonutChart33.vue'
import DonutChart34 from '@/views/graph/DonutChart34.vue'
import DonutChart35 from '@/views/graph/DonutChart35.vue'
import DonutChart36 from '@/views/graph/DonutChart36.vue'
import DonutChart38 from '@/views/graph/DonutChart38.vue'
import DonutChart39 from '@/views/graph/DonutChart39.vue'

export default {
  components: {
    DonutChart39,
    DonutChart38,
    DonutChart36,
    DonutChart35,
    DonutChart34,
    DonutChart33,
    DonutChart32,
    DonutChart31,
    DonutChart30,
    DonutChart29,
    DonutChart28,
    DonutChart27,
    DonutChart26,
    DonutChart25,
    DonutChart24,
    DonutChart23,
    DonutChart22,
    DonutChart21,
    DonutChart20,
    DonutChart19,
    DonutChart18,
    DonutChart17,
    DonutChart16,
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      mobileCardMenus: [
        {
          url: {name: 'project-home', params:{proj_id: 2}},
          name: '내부종사자 분야',
          icon: 'UsersIcon',
          activeCode: '',
          project_type: '내부종사자 분야',
        },
        {
          url: {name: 'project-home', params:{proj_id: 3}},
          name: '도급·용역·위탁사업 분야',
          icon: 'UsersIcon',
          activeCode: '',
          project_type: '도급·용역·위탁사업 분야',
        },
        {
          url: {name: 'project-home', params:{proj_id: 4}},
          name: '발주사업 분야',
          icon: 'UsersIcon',
          activeCode: '',
          project_type: '발주사업 분야',
        },
        {
          url: {name: 'project-home', params:{proj_id: 5}},
          name: '중대시민재해 분야',
          icon: 'ShieldIcon',
          activeCode: '',
          project_type: '중대시민재해 분야',
        },
      ],
      successLoadGraph: false,
      alertList: [],
    }
  },
  computed:{
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    username () {
      return this.myInfo ? this.myInfo.username : ''
    },
    hasDashboardCharts () {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts
      if (hasDashboardCharts) {
        const list = []
        for (const chart of hasDashboardCharts) {
          if (chart.visible && chart.project_id === 0) {
            const code = chart.dashboard_chart.code
            list.push({
              component: code,
              donutType: chart.donut_type,
            })
          }
        }
        return list
      }

      return undefined
    }
  },
  async created () {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(value => {
      this.successLoadGraph = true
    });
  },
  async mounted () {
  },
  methods: {
    getDataType (chart, donutType) {
      if (donutType) {
        return donutType
      }

      return 'project'
    },
    async loadAlertList () {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      }
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch('approval/LOAD_NOTIFICATION_LIST', options)

      const readList = this.$store.state.approval.alertReadList
      const unreadList = this.$store.state.approval.alertUnReadList

      this.alertList = unreadList
    },

    onClickAlert (alert) {
      const data = JSON.parse(alert.data)
      if (data && data.project_id && data.board_id && data.post_id) {
        const projectId = data.project_id
        const boardId = data.board_id
        const postId = data.post_id
        this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0.0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
  }
}
.m-alarm-list {
  width: auto;
  .board {border: 1px solid #CDCDCD;}
}
</style>
